import { useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import DataTable from "react-data-table-component";
import ReactDatePicker from "react-datepicker";
import { useParams, useNavigate } from "react-router-dom";
import { UserListTableData } from "../../../data/users/UsersList";
 import { Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";
import { ActivityHistoryColumns } from "../../../data/users/ActivityHistoryList";
import { tableHeaderStyles } from "../../../styles/ReactSelectStyles";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";

function ActivityLogsUserDeveloperPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const [filterText, setFilterText] = useState("");
  const [selectedUserId, setSelectedUserId] = useState<number | null>(
    id ? Number(id) : null
  );
  const [startDate, setStartDate] = useState<Date | null>(null);

  useEffect(() => {
     if (!id || !UserListTableData.find((u) => u.id.toString() === id)) {
      navigate(`${process.env.PUBLIC_URL}/error`, { replace: true });
    } else {
      setSelectedUserId(Number(id));
    }
  }, [id, navigate]);

  const handleDateChange = (date: Date | null) => {
    setStartDate(date);
  };

  const allActivityLogs = UserListTableData.filter(
    (user) =>
      Array.isArray(user.ActivityHistory) && user.ActivityHistory.length > 0
  ).flatMap((user) =>
    user.ActivityHistory!.map((activity) => ({
      id: user.id,
      name: user.name,
      image: user.image,
      organizationname: user.organizationname,
      ...activity,
    }))
  );

  let filteredItems = allActivityLogs;
  if (selectedUserId) {
    filteredItems = filteredItems.filter((item) => item.id === selectedUserId);
  }
  filteredItems = filteredItems.filter((item) => {
    const search = filterText.toLowerCase();
    return (
      (item.name && item.name.toLowerCase().includes(search)) ||
      (item.action && item.action.toLowerCase().includes(search))
    );
  });

  const selectedUser = selectedUserId
    ? UserListTableData.find((u) => u.id === selectedUserId)
    : null;

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <div
          id="basic-9_filter"
          className="dataTables_filter d-flex align-items-center"
        >
          <FormGroup className="d-flex flex-column align-items-stretch">
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFilterText(e.target.value)
              }
              type="search"
              value={filterText}
              placeholder={t("Search")}
            />
          </FormGroup>
        </div>
        <div
          id="basic-9_filter"
          className="dataTables_filter d-flex align-items-center ms-3"
        >
          <FormGroup className="d-flex flex-column align-items-stretch">
            <ReactDatePicker
              className="datepicker-here form-control"
              selected={startDate}
              onChange={handleDateChange}
              dateFormat="dd/MM/yyyy"
              isClearable
              placeholderText={t("Date")}
            />
          </FormGroup>
        </div>
      </>
    );
  }, [filterText, startDate, t]);

  return (
    <>
      <Breadcrumbs
        mainTitle={t("ActivitylogHistory")}
        parents={[
          { label: t("Users"), link: `${process.env.PUBLIC_URL}/users/developers` },
          { label: t("Developers"), link: `${process.env.PUBLIC_URL}/users/developers` },
        ]}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header d-flex align-items-center mb-3">
                  {selectedUser ? (
                    <>
                      <Image
                        className="media-object rounded-circle img-40 me-2"
                        src={dynamicImage(selectedUser.image)}
                        alt={selectedUser.name}
                      />
                      <P className="mb-0 fw-bold">{selectedUser.name}</P>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="list-product">
                  <div className="table-responsive">
                    <DataTable
                      data={filteredItems}
                      columns={ActivityHistoryColumns(t)}
                      striped
                      pagination
                      subHeader
                      customStyles={tableHeaderStyles}
                      subHeaderComponent={subHeaderComponentMemo}
                      pointerOnHover
                      highlightOnHover
                      noDataComponent={
                        <div className="text-center p-4 text-muted">
                          {t("NoActivityhistoryMessage")}
                        </div>
                      }
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ActivityLogsUserDeveloperPage;